import React from "react";
import { connect } from "react-redux";
import { AdvancedSearchPanel } from "cm-component-library/lib/components/AdvancedSearchPanel";
import { ThunkDispatch } from "redux-thunk";
import { Row, Col } from "reactstrap";
import { IAppState } from "../../../Common";
import {
  AdvancedSearchAction,
  toggleAdvancedSearchDropdown
} from "../../Actions/AdvancedSearchActions";
import { AdvancedSearchSettings } from "../../Models/AdvancedSearch/AdvancedSearchSettings";
import AdvancedSearchBuilder from "./AdvancedSearchBuilder";

type Props = {};

type StateProps = {
  isDropdownShowing: boolean;
  searchSettings: AdvancedSearchSettings;
};

type DispatchProps = {
  toggleAdvancedSearchDropdown: () => void;
};

function mapStateToProbs(state: IAppState): StateProps {
  return {
    isDropdownShowing: state.advancedSearch.isAdvancedSearchDropdownShowing,
    searchSettings: state.advancedSearch.settings
  };
}

function mapDispatchToProps(
  dispatch: ThunkDispatch<IAppState, {}, AdvancedSearchAction>
): DispatchProps {
  return {
    toggleAdvancedSearchDropdown: () => dispatch(toggleAdvancedSearchDropdown())
  };
}

class AdvancedSearchContainer extends React.Component<Props & StateProps & DispatchProps> {
  constructor(props: Props & StateProps & DispatchProps) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.props.toggleAdvancedSearchDropdown();
  }

  render() {
    return (
      <AdvancedSearchPanel isOpen={this.props.isDropdownShowing} onToggle={this.onToggle}>
        {/* <h4>
                    Advanced Search
                </h4>
                <hr />
                <Row>
                    <Col md={3}>
                        <AdvancedSearchBuilder title={"Categories"} selectedItemValues={[]} availableItems={[]} />
                    </Col>
                    <Col md={3}>
                        <AdvancedSearchBuilder title={"States"} selectedItemValues={[]} availableItems={[]} />
                    </Col>
                    <Col md={3}>
                        <AdvancedSearchBuilder title={"Apps"} selectedItemValues={[]} availableItems={[]} />
                    </Col>
                </Row> */}
      </AdvancedSearchPanel>
    );
  }
}

export default connect(
  mapStateToProbs,
  mapDispatchToProps
)(AdvancedSearchContainer);
